export default {
  nav: {
    main: 'Hoved',
    ordersAndInvoices: 'Ordrer og fakturaer',
    drafts: 'Kladder',
    automation: 'Automatisering',
    workspace: 'Arbejdsområde',
    templates: 'Skabeloner',
    delivery: 'Levering',
    settings: 'Indstillinger',
    shippingLabels: 'Forsendelsesmærkater',
    subscriptions: 'Abonnementer',
    support: 'Support',
    developer: 'Udvikler',
    writeReview: 'Skriv en anmeldelse',
    supportTicket: 'Supportanmodning',
    welcomeTour: 'Velkomstrundvisning',
    administratorConsole: 'Administratorkonsol',
    logout: 'Log ud',
  },
  dashboard: {
    pageTitle: 'Ordrer og fakturaer',
    pageDescription: 'Manage your orders and invoices',
    title: 'Ordrer og fakturaer',
    selectedOrders: '{count} valgte ordrer',
    completed: '% fuldført',
    processing: 'Behandler, vent venligst...',
    bulkDownload: 'Massedownload',
    upgradeBulkDownload: 'Opgrader din plan for massedownload',
    showFilters: 'Vis filtre',
    hideFilters: 'Skjul filtre',
    creatingInvoices: 'Opretter fakturaer, vent venligst...',
    bulkCreateInvoices: 'Masseopret fakturaer',
    cannotCreateAutopilot: 'Du kan ikke manuelt oprette fakturaer, når faktureringstilstanden er på autopilot.',
    exportInvoices: 'Eksporter fakturaer eller ordrer',
    capturePayments: 'Indfang betalinger manuelt',
    filterOrders: 'Filtrer ordrer',
    error: 'Hov, noget gik galt...',
    close: 'Luk',
    chooseDate: 'Vælg en dato',
    chooseIssueDate: 'Vælg en udstedelsesdato for de valgte fakturaer',
    cancel: 'Annuller',
    createInvoices: 'Opret fakturaer',
    storno: 'Storno',
    bulkOrderCapture: 'Masseindfangning af ordrer',
  },
  search: {
    createdBetween: 'Oprettet ml.',
    modifiedBetween: 'Ændret ml.',
    orderNumber: 'Ordre #',
    invoiceNumber: 'Faktura #',
    refundNumber: 'Refusion #',
    customer: 'Kunde',
    payment: 'Betaling',
    any: 'Alle',
    authorized: 'Autoriseret',
    pending: 'Afventer',
    paid: 'Betalt',
    partiallyPaid: 'Delvist betalt',
    refunded: 'Refunderet',
    voided: 'Annulleret',
    partiallyRefunded: 'Delvist refunderet',
    unpaid: 'Ubetalt',
    fulfillment: 'Opfyldelse',
    fulfilled: 'Afsendt',
    partial: 'Delvis',
    unfulfilled: 'Ikke afsendt',
    loading: 'Indlæser ordrer...',
    search: 'Søg',
  },
  orderList: {
    noCustomer: 'Ingen kunde',
    downloadOrder: 'Download ordre',
    deleteWarning: 'Vigtigt! Dette vil slette alle fakturaer og refusioner oprettet efter datoen:',
    includingInvoice: 'inklusive den valgte faktura #',
    pressOk: 'Tryk OK for at fortsætte eller Annuller for at afbryde.',
    cannotCreateAutopilot: 'Du kan ikke manuelt oprette fakturaer, når faktureringstilstanden er på autopilot.',
    createInvoice: 'Opret faktura for denne ordre',
    create: 'Opret',
    addCreditNote: 'Tilføj kreditnota',
    createStorno: 'Opret en stornofaktura',
    refund: 'Refusion',
    downloadInvoice: 'Download denne faktura',
    download: 'Download',
    default: 'Standard',
    downloadStorno: 'Download denne storno/kreditnota',
    fulfillOrder: 'Opfyld ordre',
    orderNum: 'Ordre #',
    locPrefix: 'Lok. præfiks',
    invoiceNum: 'Faktura #',
    refundNum: 'Refusion #',
    customerCol: 'Kunde',
    orderCreatedDate: 'Ordre oprettelsesdato',
    orderModifiedDate: 'Ordre ændringsdato',
    delivered: 'Leveret',
    paymentStatus: 'Betalingsstatus',
    fulfillmentStatus: 'Forsendelsestatus',
    totalOutstanding: 'Samlet udestående beløb',
    originalPrice: 'Oprindelig pris',
    noOrders: 'Din butik har ingen ordrer for den valgte status.',
    cannotCreateNoOrders: 'Du kan ikke oprette fakturaer, når der ikke er nogen ordrer.',
    createOrdersFirst: 'Opret venligst mindst én ordre og prøv igen.',
    createOrders: 'Opret ordrer',
    loadingOrders: 'Indlæser...',
    paidManual: 'Betalt - Manuel',
    paid: 'Betalt',
    refunded: 'Refunderet',
    pending: 'Afventer',
    partiallyPaid: 'Delvist betalt',
    partiallyRefunded: 'Delvist refunderet',
    fulfilled: 'Afsendt',
    unfulfilled: 'Ikke afsendt',
    deliveryPending: 'Afventer',
    deliverNow: 'Lever nu',
    deliveryPartial: 'Delvis',
    notDelivered: 'Ikke leveret',
    deliverAgain: 'Lever igen',
    deliveryDetails: 'Leveringsdetaljer',
    deliveryFailed: 'Levering fejlede',
    sent: 'Sendt',
    failed: 'Fejlet',
    toLabel: 'Til',
    folderLabel: 'Mappe',
    open: 'Åben',
    invoice: 'Faktura',
    creditNote: 'Kreditnota',
    stornoLabel: 'Storno',
    unknown: 'Ukendt',
    googleDrive: 'Google Drive',
    clientsTablet: 'Klient-tablet',
    shippyPro: 'ShippyPro',
    emailChannel: 'E-mail',
    ftpChannel: 'FTP',
    revertToDate: 'Gendan til denne dato',
    add: 'Tilføj',
    close: 'Luk',
  },
  downloadDialog: {
    downloadType: 'Download {type}...',
    selectTemplate: 'Vælg en skabelon fra galleriet for at eksportere ordrer, fakturaer, stornofakturaer eller kreditnotaer.',
    getMoreTemplates: 'Hent flere skabeloner',
    createNewTemplate: 'Opret en ny skabelon',
    allCreatedBetween: 'Alle oprettede {type} mellem',
    selectedType: 'Valgte {type}',
    and: 'og',
    status: 'Status',
    any: 'Alle',
    open: 'Åben',
    closed: 'Lukket',
    cancelled: 'Annulleret',
    paymentStatus: 'Betalingsstatus',
    fulfillmentStatus: 'Forsendelsestatus',
    fulfilled: 'Afsendt',
    partial: 'Delvis',
    unfulfilled: 'Ikke afsendt',
    authorized: 'Autoriseret',
    pending: 'Afventer',
    paid: 'Betalt',
    partiallyPaid: 'Delvist betalt',
    refunded: 'Refunderet',
    voided: 'Annulleret',
    partiallyRefunded: 'Delvist refunderet',
    unpaid: 'Ubetalt',
    format: 'Format',
    forLocation: 'For lokation',
    advancedOptions: 'Avancerede indstillinger',
    exportHSCodes: 'Eksporter lager HS-koder (langsommere)',
    noteChrome: 'Bemærk: For optimal download anbefales Chrome og deaktivering af adblocker.',
    downloadIndividually: 'Download enkeltvis',
    downloadGrouped: 'Download grupperet',
  },
  templates: {
    pageTitle: 'Skabeloner',
    pageDescription: 'Customize your invoice templates',
    title: 'Skabeloner',
    installTranslated: 'Installer en oversat skabelon',
    installTranslatedDesc: 'Vælg et andet sprog ved at klikke på denne knap.',
    createNew: 'Opret en ny skabelon om nødvendigt',
    createNewDesc: 'Klik på denne knap for at oprette en ny skabelon, hvis det er nødvendigt.',
    customize: 'Tilpas skabeloner',
    customizeDesc: 'Klik på standardskabelonen for at tilpasse den. Du kan ændre logo, farver og for mere avancerede brugere, koden bag.',
    defaultTemplate: 'Faktura, storno og kreditnota (Standard)',
    logo: 'Logo',
    colorPalette: 'Farvepalet',
    getColorPalettes: 'Hent farvepaletter',
    paperSize: 'Papirstørrelse',
    format: 'Format',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Orientering',
    landscape: 'Liggende',
    portrait: 'Stående',
    margin: 'Margen (cm)',
    unsavedChanges: 'Ikke-gemte ændringer',
    discard: 'Kassér',
    save: 'Gem',
  },
  labels: {
    pageTitle: 'Forsendelsesmærkater',
    pageDescription: 'Create and manage shipping labels',
    title: 'Forsendelsesmærkater',
    glsRequiresPro: 'GLS forsendelsesmærkater til EØU kræver Professional-planen.',
    upgradeDesc: 'Opgrader til Professional for at oprette og administrere forsendelsesmærkater.',
    upgradePlan: 'Opgrader din plan',
    eeuGls: 'EØU GLS',
    enabled: 'Aktiveret',
    country: 'Land',
    hungary: 'Ungarn',
    slovakia: 'Slovakiet',
    czech: 'Tjekkiet',
    romania: 'Rumænien',
    slovenia: 'Slovenien',
    croatia: 'Kroatien',
    senderId: 'Afsender-ID',
    username: 'Brugernavn',
    password: 'Adgangskode',
    name: 'Navn',
    city: 'By',
    address: 'Adresse',
    zipCode: 'Postnummer',
    contactPerson: 'Kontaktperson',
    phone: 'Telefon',
    email: 'E-mail',
    glsServices: 'GLS-tjenester',
    expressService: 'Eksprestjeneste',
    exchangeService: 'Byttetjeneste',
    smsService: 'SMS-tjeneste',
    smsText: 'SMS-tekst',
    preAdviceService: 'Forudadvisering',
    unsavedChanges: 'Ikke-gemte ændringer',
    discard: 'Kassér',
    save: 'Gem',
  },
  billing: {
    pageTitle: 'Fakturering',
    pageDescription: 'Manage your subscription and billing',
    title: 'Fakturering',
    subscriptionFor: 'Abonnementsplan for butik',
    currentlySubscribed: 'Du abonnerer i øjeblikket på',
    plan: 'plan',
    cancelSubscription: 'Annuller abonnement',
    upgradePlan: 'Opgrader din plan',
    professional: 'Professional',
    proPriceMonthly: '$29.99 / måned',
    upgrade: 'Opgrader',
    includesAllStarter: 'Inkluderer alle Starter-funktioner, plus:',
    proFeature1: 'Global overholdelsespakke: Lokationsbaserede præfikser og brugerdefineret sekventiel nummerering',
    proFeature2: 'Smart lokalisering: Automatisk oversatte e-mails og lokaliserede PDF-vedhæftninger',
    proFeature3: 'Komplet B2B-dokumentlivscyklus: Proformaer, B2B-tilbud og kreditnotaer',
    proFeature4: 'B2B-regnskabssynkronisering: 3-decimals enhedspræcision og visning af flere valutaer',
    proFeature5: 'Automatiske sikkerhedskopier: Kopiér fakturaer automatisk til sikker FTP eller Google Drive',
    proFeature6: 'Shopify Flow: Automatiser fakturagenerering, levering og storno via Flow-udløsere og handlinger',
    proFeature7: 'Avanceret AI-logik: Brug den indbyggede AI til komplekse betingede layoutklausuler',
    proFeature8: 'UBL XML & ZUGFeRD / Factur-X eksport (europæisk e-fakturering)',
    proFeature9: 'EPC QR-koder til øjeblikkelige mobile POS-betalinger',
    proFeature10: 'GLS forsendelsesmærkater til EØU',
    proFeature11: '7-års skattemæssig opbevaring',
    currentlyUsing: 'Du bruger i øjeblikket vores',
    free: 'gratis',
    subscriptionPlan: 'abonnementsplan.',
    monthlyUsage: 'Månedligt forbrug',
    monthlyGenerated: '{count} / 50 fakturaer denne måned',
    monthlyLimitReached: 'Månedlig grænse nået. Opgrader til Starter for ubegrænsede fakturaer.',
    freePlan: 'Gratis plan',
    freeToInstall: 'Gratis at installere',
    freeFeature1: 'Op til 50 fakturaer/ordrer pr. måned',
    freeFeature2: 'Adgang til alle 31+ foruddefinerede skabeloner',
    freeFeature3: 'Grundlæggende AI-copilot',
    freeFeature4: 'Standard PDF-downloads og udskrivning',
    freeFeature5: 'Standard dokumentpakke (Fakturaer, følgesedler, kvitteringer)',
    freeFeature6: '3 måneders sikker fakturaopbevaring',
    starterPlan: 'Starter-plan',
    starterPrice: '$9.99 / måned',
    starterPricePerInvoice: '+ 3¢ pr. oprettet faktura',
    subscribe: 'Abonner',
    starterFeature1: 'Ubegrænsede fakturaer og ordrer',
    starterFeature2: 'Automatisk PDF-levering via e-mail',
    starterFeature3: 'Fuld adgang til hybrideditor og AI-copilot',
    starterFeature4: 'Shopify POS og stregkodeintegration',
    starterFeature5: 'Shopify Flow: Udløsere og handlinger til fakturaautomatisering',
    starterFeature6: 'UBL XML / PEPPOL & ZUGFeRD / Factur-X eksport (e-fakturering)',
    starterFeature7: '1 års sikker fakturaopbevaring',
    proTaxOverrides: 'Brugerdefinerede skattetilsidesættelser: Moms/GST pr. produkt og SKU-niveau satser',
    unsavedChanges: 'Ikke-gemte ændringer',
    discard: 'Kassér',
    save: 'Gem',
  },
  autopilot: {
    pageTitle: 'Automatisering',
    pageDescription: 'Automate invoice creation and management',
    title: 'Automatisering',
    autoCreate: 'Opret fakturaer automatisk',
    disabled: 'Deaktiveret (Manuel)',
    whenCreated: 'Når ordrer oprettes',
    whenFulfilled: 'Når ordrer opfyldes',
    whenPaid: 'Når ordrer betales',
    autoCreateDesc: 'Fakturaer oprettes på den dato, hvor ordrer oprettes, opfyldes eller betales.',
    autoStorno: 'Automatisk stornering af fakturaer',
    whenCancelled: 'Når ordrer annulleres eller refunderes',
    autoStornoDesc: 'Stornofakturaer oprettes på den dato, hvor ordrer annulleres eller refusioner oprettes.',
    cannotAutoFree: 'Automatisk oprettelse af fakturaer kan ikke udføres med den gratis plan.',
    upgradePlan: 'Opgrader din plan',
    unsavedChanges: 'Ikke-gemte ændringer',
    discard: 'Kassér',
    save: 'Gem',
  },
  delivery: {
    pageTitle: 'Levering',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Levering',
    settings: 'Indstillinger',
    useOrderNumbers: 'Brug ordrenumre til filer',
    sendIfCountry: 'Send hvis faktureringsadressens land er',
    countryCodesHint: 'Angiv alle landekoder adskilt med semikolon.',
    sendForTags: 'Send for kunder, der har et af de angivne tags',
    tagsHint: 'Angiv alle tags adskilt med semikolon.',
    emailDelivery: 'E-maillevering',
    sendAsPdf: 'Send fakturaer som PDF-vedhæftninger til kunder',
    autoSend: 'Send automatisk, når en faktura oprettes',
    subject: 'Emne',
    body: 'Brødtekst',
    xmlAttachments: 'XML-vedhæftninger',
    attachUbl: 'Vedhæft UBL/PEPPOL XML (E-Factura)',
    attachZugferd: 'Vedhæft ZUGFeRD / Factur-X XML',
    sendTestEmail: 'Send test-e-mail',
    sending: 'Sender...',
    customSmtp: 'Brugerdefineret SMTP-server',
    customSmtpDesc: 'Brug din egen mailserver i stedet for standard',
    enableSmtp: 'Aktivér brugerdefineret SMTP',
    smtpHost: 'SMTP-vært',
    port: 'Port',
    useSsl: 'Brug SSL/TLS',
    username: 'Brugernavn',
    password: 'Adgangskode',
    fromEmail: 'Fra e-mail',
    fromName: 'Fra navn',
    shopifyLiquid: 'Shopify Liquid-skabelon',
    pasteInto: 'Indsæt dette i din',
    orderConfirmation: 'ordrebekræftelsesskabelon',
    toAddLink: 'for at tilføje et downloadlink.',
    downloadInvoice: 'Download din faktura',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Send forespørgsler til ClientsTablet, når fakturaer oprettes',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'Send PDF-fakturaer som tolddokumenter til ShippyPro for lande uden for EU',
    ftpBackup: 'FTP/SFTP-sikkerhedskopiering',
    ftpDesc: 'Kopiér automatisk fakturaer til din server',
    enableFtp: 'Aktivér automatisk FTP-sikkerhedskopiering',
    host: 'Vært',
    useSftp: 'Brug SFTP (sikker)',
    destinationFolder: 'Destinationsmappe',
    xmlFiles: 'XML-filer',
    includeUbl: 'Inkludér UBL/PEPPOL XML (E-Factura)',
    includeZugferd: 'Inkludér ZUGFeRD / Factur-X XML',
    testConnection: 'Test forbindelse',
    testing: 'Tester...',
    pro: 'PRO',
    upgradeFtp: 'Opgrader til Professional for automatisk at kopiere fakturaer til din FTP/SFTP-server.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Synkroniser fakturaer automatisk til dit Drive',
    connected: 'Forbundet',
    disconnect: 'Afbryd',
    notWorking: 'Virker det ikke? Gå til',
    googlePermissions: 'Google-tilladelser',
    removeThenReconnect: 'fjern Invoice Browse, og tilslut derefter igen.',
    connectGoogleDrive: 'Tilslut Google Drive',
    upgradeGoogleDrive: 'Opgrader til Professional for automatisk at synkronisere fakturaer til Google Drive.',
    unsavedChanges: 'Ikke-gemte ændringer',
    discard: 'Kassér',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Gem',
  },
  bookkeeping: {
    pageTitle: 'Indstillinger',
    pageDescription: 'Configure your invoice settings',
    title: 'Indstillinger',
    owner: 'Ejer',
    email: 'Email',
    phone: 'Telefon',
    keepDifferentNumbering: 'Behold forskellig fakturanummerering for hver ordrelokation',
    keepDifferentNumberingDisabled: 'Behold forskellig fakturanummerering for hver ordrelokation er ikke en mulighed, der er aktiveret med din plan.',
    locationEmailDesc: 'Dette giver dig mulighed for at sende e-mails og fakturaer oversat baseret på ordrelokationen: lagerlokation, forsendelsesadresse eller faktureringsadresse',
    upgradePlan: 'Opgrader din plan',
    matchingCriteria: 'Matchningskriterier',
    locationId: 'Lokations-ID',
    shippingCountryCode: 'Forsendelsesadresse landekode',
    billingCountryCode: 'Faktureringsadresse landekode',
    matchLocationDesc: 'Match en lokation baseret på ordrelokations-ID, forsendelsesadresse eller faktureringsadresse landekode.',
    companyInfo: 'Virksomhedsoplysninger',
    name: 'Navn',
    website: 'Hjemmeside',
    registrationNumber: 'Registreringsnummer',
    taxId: 'CVR-nummer',
    addressSection: 'Adresse',
    streetName: 'Gadenavn',
    streetNumber: 'Gadenummer',
    zip: 'Postnummer',
    city: 'By',
    region: 'Region',
    country: 'Land',
    bankingInfo: 'Bankoplysninger',
    bankName: 'Banknavn',
    swift: 'Swift',
    currency: 'Valuta',
    iban: 'IBAN',
    invoicing: 'Fakturering',
    decimalPlaces: 'Decimalpladser',
    invoicesPrefix: 'Fakturapræfiks',
    currentInvoiceNumber: 'Nuværende fakturanummer',
    creditNotesPrefix: 'Kreditnotapræfiks',
    currentCreditNoteNumber: 'Nuværende kreditnotanummer',
    lastInvoiceDate: 'Sidste fakturadato',
    noInvoicesYet: 'Ingen fakturaer oprettet endnu.',
    confirmReverting: 'Bekræft tilbagerulning',
    allInvoicesAfter: 'Alle fakturaer og deres storno udstedt efter',
    willBeRemoved: 'vil blive fjernet. Fortsæt med at tilbagerulle systemet?',
    cancel: 'Annuller',
    revert: 'Tilbagerul',
    revertDesc: 'Tilbagerulning af systemet vil slette alle fakturaer oprettet efter den valgte dato.',
    revertToDate: 'Tilbagerul til denne dato',
    reverting: 'Tilbageruller systemet, vent venligst...',
    useOrderNumbering: 'Brug ordrenummerering',
    showVat: 'Vis moms på fakturaer',
    overrideTaxes: 'Tilsidesæt skatter',
    pricesIncludeTax: 'Priser inkluderer moms',
    productsTaxRate: 'Produkters momssats',
    shippingTaxRate: 'Forsendelsens momssats',
    skusSeparated: 'SKU\'er adskilt med semikolon',
    skusTaxRate: 'SKU-momssats',
    useOrderDates: 'Brug ordredatoer til fakturaer',
    convertCurrency: 'Konverter priser til den valuta, kunden betaler i',
    unsavedChanges: 'Ikke-gemte ændringer',
    discard: 'Kassér',
    save: 'Gem',
  },
  drafts: {
    pageTitle: 'Kladder',
    pageDescription: 'Manage your draft orders',
    title: 'Kladder',
    download: 'Download',
    newDraft: 'Ny kladde',
    exporting: 'Eksporterer {status}%...',
    accessNotGranted: 'Adgang til kladdeordrer er ikke givet. Venligst',
    reLogin: 'log ind igen',
    toGrantPermissions: 'for at give de nødvendige "Kladdeordrer"-tilladelser.',
    pushFailed: 'Push til Shopify mislykkedes:',
    exportError: 'Eksportfejl:',
    confirmDelete: 'Er du sikker på, at du vil slette denne kladde?',
    incompleteCustomer: 'Kundedata er ufuldstændige:',
    pushWithoutCustomer: 'Kladden vil blive sendt til Shopify uden kundedata. Fortsæt?',
    customerNotInShopify: 'Denne kunde findes ikke i Shopify endnu.',
    warnings: 'Advarsler:',
    createCustomerAndPush: 'Opret kunden i Shopify og send kladdeordren?',
    downloadTitle: 'Download kladder',
    cancel: 'Annuller',
  },
  draftEdit: {
    number: "Nummer",
    prefix: "Præfiks",

    newDraft: 'Ny kladde',
    editDraft: 'Rediger kladde',
    viewInShopify: 'Se i Shopify',
    back: 'Tilbage',
    createDraft: 'Opret kladde',
    saveChanges: 'Gem ændringer',
    documentType: 'Dokumenttype',
    draftOrder: 'Kladdeordre',
    quote: 'Tilbud',
    proforma: 'Proforma',
    manualInvoice: 'Manuel faktura',
    currency: 'Valuta',
    expiryDate: 'Udløbsdato',
    status: 'Status',
    draft: 'Kladde',
    sent: 'Sendt',
    accepted: 'Accepteret',
    customer: 'Kunde',
    firstName: 'Fornavn',
    lastName: 'Efternavn',
    email: 'E-mail',
    phone: 'Telefon',
    company: 'Virksomhed',
    taxId: 'CVR-nummer',
    billingAddress: 'Faktureringsadresse',
    address: 'Adresse',
    aptSuite: 'Lejlighed/Suite',
    city: 'By',
    province: 'Region',
    countryField: 'Land',
    zip: 'Postnummer',
    shippingAddress: 'Forsendelsesadresse',
    sameAsBilling: 'Samme som fakturering',
    lineItems: 'Linjevarer',
    shipping: 'Forsendelse',
    shippingTitle: 'Titel',
    shippingPlaceholder: 'f.eks. Standardforsendelse',
    price: 'Pris',
    note: 'Note',
    notePlaceholder: 'Intern note eller besked til kunden...',
    summary: 'Oversigt',
    subtotal: 'Subtotal',
    discounts: 'Rabatter',
    tax: 'Moms',
    total: 'Total',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Indtast din butiksadresse',
    loginWith: 'Log ind med',
    createAccount: 'Opret en ny konto',
    placeholder: 'dit-butiksnavn',
    shopRequired: 'Butiksnavn er påkrævet',
    login: 'Log ind',
    shopify: 'Shopify',
    terms: 'Vilkår og betingelser',
    privacy: 'Privatlivspolitik',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Nyder du Invoice Browse?',
    description: 'Du har oprettet dine første fakturaer! Hvis du finder appen nyttig, hjælper en hurtig anmeldelse på Shopify App Store os meget.',
    reward: 'Som tak nulstiller vi din månedlige forbrugstæller til 0',
    leaveReview: 'Skriv en anmeldelse',
    maybeLater: 'Måske senere',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Velkommen til Invoice Browse',
    welcomeContent: 'Lad mig vise dig, hvordan du kan bruge den.',
    dashboardTitle: 'Dashboard',
    dashboardContent: 'Skærmen du ser er hovedoversigten. Her kan du finde alle ordrer, og du kan eksportere dem til forskellige dokumenttyper som: fakturaer, følgesedler og andre.',
    automationTitle: 'Gør dit liv lettere',
    automationContent: 'Aktivér automatisering for at oprette fakturaer, når ordrer betales eller refunderes.',
    templatesTitle: 'Tilpas skabeloner',
    templatesContent: 'Gå ind her for at oversætte din skabelon, tilpasse den eller oprette en ny.',
    deliveryTitle: 'Levering',
    deliveryContent: 'Konfigurer vores app til automatisk at kopiere oprettede dokumenter til FTP, Google Drive eller som vedhæftninger til e-mails.',
    settingsTitle: 'Indstillinger',
    settingsContent1: 'Juster virksomhedens telefonnummer, e-mail og andre felter, der bruges på dokumenter.',
    settingsContent2: 'Ændr dokumentets startnummer eller slet dokumenter oprettet efter en dato.',
    settingsContent3: 'Tilsidesæt momssatser for forsendelse og produkter',
    settingsContent4: 'Ændr decimalpladser for tal',
    reviewTitle: 'Skriv en anmeldelse',
    reviewContent: 'Støt vores team ved at skrive os en god anmeldelse!',
    tourTitle: 'Velkomstrundvisning',
    tourContent: 'Hej, du kan åbne denne rundvisning igen herfra.',
    createDocTitle: 'Opret dit første dokument',
    createDocContent: 'Klik på Opret-knappen for at oprette dit første dokument.',
    docNumberTitle: 'Dokumentnummer',
    docNumberContent: 'Første dokument har nummer 1 tildelt. Hvis du vil starte med et andet nummer, kan du ændre dette under Indstillinger.',
    downloadDocTitle: 'Download dokument',
    downloadDocContent: 'Klik på Download-rullelisten og vælg en dokumentskabelon for at eksportere din ordre som PDF.',
  },
  common: {
    save: 'Gem',
    cancel: 'Annuller',
    close: 'Luk',
    discard: 'Kassér',
    delete: 'Slet',
    edit: 'Rediger',
    create: 'Opret',
    loading: 'Indlæser...',
    unsavedChanges: 'Ikke-gemte ændringer',
    upgradePlan: 'Opgrader din plan',
  },
  languageSelector: {
    label: 'Sprog',
    auto: 'Automatisk registrering',
  },
  draftList: {
    draftNum: 'Kladde #',
    shopifyId: 'Shopify ID',
    type: 'Type',
    customer: 'Kunde',
    total: 'Total',
    status: 'Status',
    delivered: 'Leveret',
    date: 'Dato',
    actions: 'Handlinger',
    noCustomer: 'Ingen kunde',
    noDrafts: 'Ingen kladder eller tilbud fundet.',
    loading: 'Indlæser...',
    download: 'Download',
    default: 'Standard',
    pending: 'Afventer',
    deliverNow: 'Lever nu',
    deliveryDetails: 'Leveringsdetaljer',
    sent: 'Sendt',
    failed: 'Fejlet',
    deliverAgain: 'Lever igen',
    partial: 'Delvist',
    notDelivered: 'Ikke leveret',
    deliveryFailed: 'Levering fejlede',
    unknown: 'Ukendt',
    edit: 'Rediger',
    send: 'Send',
    pushToShopify: 'Send til Shopify',
    complete: 'Fuldfør',
    duplicate: 'Dupliker',
    delete: 'Slet',
    quote: 'Tilbud',
    proforma: 'Proforma',
    draftOrder: 'Kladdeordre',
    manualInvoice: 'Manuel faktura',
  },
  draftSearch: {
    createdBtw: 'Oprettet ml.',
    draftNum: 'Draft #',
    shopifyId: 'Shopify ID',
    customer: 'Kunde',
    status: 'Status',
    type: 'Type',
    delivery: 'Levering',
    any: 'Alle',
    draft: 'Kladde',
    sent: 'Sendt',
    accepted: 'Accepteret',
    expired: 'Udløbet',
    converted: 'Konverteret',
    cancelled: 'Annulleret',
    quote: 'Tilbud',
    proforma: 'Proforma',
    draftOrder: 'Kladdeordre',
    manualInvoice: 'Manuel faktura',
    delivered: 'Leveret',
    notDelivered: 'Ikke leveret',
    pending: 'Afventer',
    search: 'Søg',
  },
  draftDownload: {
    title: 'Download Kladde #...',
    selectTemplate: 'Select a template from the gallery to export drafts, quotes, or proformas.',
    allDraftsBetween: 'All drafts between',
    selectedDrafts: 'Selected drafts',
    and: 'and',
    status: 'Status',
    documentType: 'Type',
    any: 'Alle',
    draft: 'Kladde',
    sent: 'Sendt',
    accepted: 'Accepteret',
    expired: 'Udløbet',
    converted: 'Konverteret',
    cancelled: 'Annulleret',
    quote: 'Tilbud',
    proforma: 'Proforma',
    draftOrder: 'Kladdeordre',
    manualInvoice: 'Manuel faktura',
    format: 'Format',
    noTemplates: 'No templates found',
    noTemplatesForType: 'No templates found for document type "{type}".',
    installTemplates: 'Install templates',
    toStartExporting: 'to start exporting.',
    noteChrome: 'Note: For optimal download Chrome browser is recommended and any Adblocker to be disabled.',
    cancel: 'Cancel',
    downloadIndividually: 'Download Individually',
    downloadGrouped: 'Download Grouped',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Installer ny skabelon',
    tabStyle: 'Stil',
    tabContent: 'Indhold',
    tabTranslations: 'Oversættelser',
    tabSettings: 'Indstillinger',
    tabCode: 'Kode',
    tabCopilot: 'AI-Kopilot',
    logo: 'Logo',
    colorPalette: 'Farvepalet',
    colorText: 'Text',
    colorBg: 'BG',
    colorBorder: 'Border',
    colorPrimary: 'Primary',
    colorAccent: 'Accent',
    font: 'Font',
    fontDefault: 'Default (DM Sans)',
    fontSize: 'Font Size',
    fontSizeDefault: 'Default (11.5px)',
    fontSizeCompact: 'Compact',
    fontSizeSmall: 'Small',
    fontSizeMediumSmall: 'Medium Small',
    fontSizeMedium: 'Medium',
    fontSizeMediumLarge: 'Medium Large',
    fontSizeLarge: 'Large',
    fontSizeExtraLarge: 'Extra Large',
    documentTitle: 'Document Title',
    documentTitlePlaceholder: 'e.g. Invoice, Tax Invoice, Factura...',
    noToggleSupport: 'This template does not support toggle controls. Switch to a gallery template for full customization.',
    sections: 'Sections',
    shippingAddress: 'Shipping address',
    bankPaymentDetails: 'Bank / payment details',
    paymentStatusBadge: 'Payment status badge',
    orderNotes: 'Order notes',
    trackingFulfillment: 'Tracking / fulfillment info',
    termsConditions: 'Terms & conditions',
    signatureLines: 'Signature lines',
    qrCode: 'QR code',
    lineItems: 'Line Items',
    taxColumns: 'Tax columns (VAT / GST)',
    productSku: 'Product SKU',
    productImages: 'Product images',
    discountBreakdown: 'Discount breakdown',
    itemWeight: 'Item weight',
    hsCode: 'HS code (customs)',
    mergeDiscounts: 'Merge discounts into product price',
    showOrderDiscountAsSummary: 'Show order discount as a summary line',
    totals: 'Totals',
    subtotalBeforeTax: 'Subtotal (before tax)',
    taxBreakdownByRate: 'Tax breakdown by rate',
    shippingCostSeparate: 'Shipping cost as separate line',
    dueDate: 'Due date',
    formatting: 'Formatting',
    dateFormat: 'Date format',
    decimalPlaces: 'Decimal places',
    paymentTerms: 'Payment terms',
    paymentTermsNone: 'None',
    thankYouMessage: 'Thank you message',
    thankYouPlaceholder: 'Thank you for your business!',
    countryMatchTitle: 'Use this template when shipping or billing address matches this country',
    addressType: 'Address Type',
    addressDisabled: 'Disabled',
    addressShipping: 'Shipping Address',
    addressBilling: 'Billing Address',
    country: 'Country',
    anyCountry: 'Any country',
    countryMatchDesc: 'When enabled, this template will be used automatically for orders where the selected address matches the chosen country.',
    languagePreset: 'Language Preset',
    selectLanguage: 'Select a language...',
    languagePresetDesc: 'Selecting a language fills in all labels below. You can then customize individual fields.',
    paperSize: 'Paper Size',
    format: 'Format',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    margin: 'Margin (cm)',
    template: 'Template',
    templateName: 'Name',
    systemAlias: 'System Alias',
    systemAliasDesc: 'for POS/Admin URL routes',
    systemAliasNone: 'None',
    defaultTemplate: 'Default template',
    defaultTemplateDesc: 'Used for direct links shared with customers.',
    posRouteDesc: 'Maps to /template/[alias]/receipt.pdf for POS integration.',
    documentType: 'Document Type',
    invoiceCreditNote: 'Invoice + Credit Note',
    order: 'Order',
    invoiceOnly: 'Invoice only',
    quoteEstimate: 'Quote / Estimate',
    proformaInvoice: 'Proforma Invoice',
    refund: 'Refund',
    stornoInvoice: 'Storno Invoice',
    creditNoteOnly: 'Credit Note only',
    reportLiquid: 'Report (Liquid only)',
    hideRemovedItems: 'Hide removed/refunded line items',
    location: 'Location',
    locationEmpty: 'Leave empty to use for all locations',
    dangerZone: 'Danger Zone',
    dangerZoneDesc: 'Permanently remove this template from your account.',
    removeTemplate: 'Remove template',
    bodyTemplate: 'Body Template',
    bodyTemplateDesc: 'Uses Mustache or Liquid syntax. Click a snippet:',
    rowTemplate: 'Row Template',
    rowTemplateDesc: 'Rendered once per line item. Click a snippet:',
    variableReference: 'Variable Reference',
    formatCode: 'Format Code',
    insert: 'Insert',
    copy: 'Copy',
    loadModelContinue: 'Load Model & Continue',
    cancel: 'Cancel',
    copilotPlaceholder: 'Try: translate to Romanian, show tax columns, add barcode, use teal palette...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Undo',
    redo: 'Redo',
    aiThinking: 'AI is thinking...',
    proposedChanges: 'Proposed Changes',
    applyChanges: 'Apply Changes',
    dismiss: 'Dismiss',
    aiEngineReady: 'AI Engine ready',
    loadingAiModel: 'Loading AI model...',
    aiEngineOff: 'AI Engine off —',
    loadForAdvanced: 'load for advanced edits',
    instantCommands: 'translate, show/hide sections, add snippets, change font/colors/paper',
    aiEngineDesc: 'structural HTML edits, layout changes, custom modifications',
    aiLocalDesc: 'Model runs locally via WebGPU — no data leaves your browser. Larger models are more accurate but use more VRAM.',
    aiUpgradeDesc: 'upgrade to Starter or Professional to unlock advanced AI template editing.',
    upgrade: 'Upgrade',
    loadAiQuestion: 'Load AI Engine?',
    loadAiDesc: 'The on-device AI model will download and run locally using WebGPU. This requires ~1-3 GB of free VRAM/RAM and a modern GPU (M1+ Mac, or discrete GPU on Windows/Linux).',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/da.js